import moment from "moment";

export function ObjectToArray(obj) {
  let keys = [];
  for (const key in obj) {
    keys.push(obj[key]);
  }
  return { keys };
}

export function saveToLocalStore(key, value) {
  if (typeof window !== undefined);
  localStorage.setItem(String(key), JSON.stringify(value));
}

export function localCache(key) {
  try {
    let cache = localStorage.getItem(key);
    if (cache) {
      return JSON.parse(cache);
    }
    return {};
  } catch (error) {
    return {};
  }
}

// get timeing date format
export function timingDate(dateObject) {
  const selectedTime = moment(dateObject);
  // format the selected time as "11:59 PM"
  const formattedTime = selectedTime.format("h:mm A");
  return formattedTime;
}

function isValidDate(date) {
  const d = new Date(date);
  return !isNaN(d);
}

export function getTimeWithTodayDate(timeString) {
  const today = new Date();
  const [hour, minute] = timeString.split(":").map((str) => parseInt(str, 10));
  let dateWithTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), hour, minute);

  if (timeString.includes("PM") && hour !== 12) {
    dateWithTime.setHours(dateWithTime.getHours() + 12);
  }

  if (isValidDate(dateWithTime)) {
    return dateWithTime;
  }

  return null;
}

// Sort data by date
export function dataSort(arr, key) {
  return arr.sort((a, b) => {
    const dateA = new Date(a[key]);
    const dateB = new Date(b[key]);
    return dateB - dateA;
  });
}

export function paramToJson(param) {
  try {
    // Removing the "?" symbol from the parameter
    param = param.replace("?", "");

    // Splitting the parameter into key-value pairs
    var pairs = param.split("&");

    // Creating an object to store the key-value pairs
    var jsonObj = {};

    // Iterating over the pairs and adding them to the object
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split("=");
      var key = pair[0];
      var value = pair[1];
      jsonObj[key] = value;
    }

    // Converting the object to JSON format
    var jsonStr = JSON.parse(JSON.stringify(jsonObj));

    return jsonStr;
  } catch (error) {
    return {};
  }
}

export function imageToCardImg(img) {
  const num = extractNumberFromUrl(img);
  return `https://storage.googleapis.com/doorway-store/mobile/${num}.webp`;
}

export function imageToDetailImg(img) {
  const num = extractNumberFromUrl(img);
  return `https://storage.googleapis.com/doorway-store/detail/${num}.webp`;
}

function extractNumberFromUrl(url) {
  // Regular expression to match numbers in the URL
  const regex = /(\d+)/;
  // Extracting numbers from the URL using the regular expression
  const match = url.match(regex);

  // If there's a match, return the first matched number
  if (match && match.length > 0) {
    return match[0];
  } else {
    // If no numbers found in the URL, return null or any other desired value
    return null;
  }
}
